import { useMemoizedFn, useUnmount } from 'ahooks';
import useOperateDPSReport from './useOperateDPSReport';
import { getStorageReportTitle, getStorageReport, removeStorageReport, transform2MockIdBatch } from '../../utils';
import { useState } from 'react';
import type { IDPSReportModuleTitles, IDPSReportVOV3 } from '@gp/types/dpsReport/v3';
import type { IDPSReportFormValue } from '../types';

export default function useEditDPSReport(props?: {
  setTitles?: (payload: IDPSReportModuleTitles) => void;
  // 获取当前周报的value
  getReport?: () => IDPSReportFormValue;
  // 设置当前周报的value
  setReport?: (payload: Partial<IDPSReportFormValue>) => void;
  // 初始化
  initialize?: (payload: IDPSReportVOV3) => void;
}) {
  const { setTitles, getReport, setReport, initialize } = props || {};

  const [reportParams, setReportParams] = useState({});

  const reportTitle = getStorageReportTitle();
  const { report_id: reportId, start_date: startDate, end_date: endDate } = getStorageReport();

  const getInitialFilter = useMemoizedFn(() => ({ start_date: startDate, end_date: endDate }));

  const updateReportPage = useMemoizedFn(() => {
    const storageReport = getStorageReport();
    const {
      comment_title: commentTitle,
      comment,
      project_comment: projectComment,
      changes_title: changesTitle,
      changes,
      memo_title: memoTitle,
      memo,
      calendar_title: calendarTitle,
      calendar: calendarsData,
    } = storageReport || {};
    const { start_date: calendarsStartDate, end_date: calendarsEndDate, list: calendars } = calendarsData || {};
    const titlesTmp = {
      comment_title: commentTitle || '',
      changes_title: changesTitle || '',
      memo_title: memoTitle || '',
      calendar_title: calendarTitle || '',
    };
    const reportTmp = {
      comment: comment || '',
      project_comment: transform2MockIdBatch(projectComment),
      changes: transform2MockIdBatch(changes),
      memo: transform2MockIdBatch(memo),
      calendar: {
        start_date: calendarsStartDate || '',
        end_date: calendarsEndDate || '',
        list: transform2MockIdBatch(calendars),
      },
    };
    setTitles?.({ ...titlesTmp });
    setReport?.({ ...reportTmp });
    setReportParams({ ...titlesTmp, ...reportTmp });
    initialize?.({ ...titlesTmp, ...reportTmp } as any);
    setIsLoading(false);
  });

  const {
    isGuide,
    isLoading,
    isCalendarInnerLoading,
    setIsCalendarInnerLoading,
    setIsLoading,
    isSubmitting,
    submitType,
    reportHelper,
    projects,
    filter,
    onCalendarRefreshData,
    onSubmit,
  } = useOperateDPSReport({
    pageId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT',
    pageLogOthers: {
      uidType: 'dps_report_id',
      uid: reportId || '',
      extInfo: reportTitle || '',
    },
    confirmBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_CONFIRM_SUBMIT',
    publishBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_PUBLISH_SUBMIT',
    refreshCalendarBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_REFRESH_CALENDAR_SUBMIT',
    getInitialFilter,
    updateReportPage,
    getReport,
    setReport,
  });

  useUnmount(() => {
    removeStorageReport();
  });

  return {
    isGuide,
    isLoading,
    isCalendarInnerLoading,
    setIsCalendarInnerLoading,
    isSubmitting,
    submitType,
    reportHelper,
    projects,
    filter,
    onCalendarRefreshData,
    onSubmit,
    reportParams,
  };
}
